import { override } from 'flarum/common/extend';
import Post from 'flarum/forum/components/Post';
import app from 'flarum/forum/app';
/**
 * Extend the flagReason function to support 'spam' type flags.
 */
export default function addSpamFlagType() {
  override(Post.prototype, 'flagReason', function (originalReason, flag) {
    // If the flag is of type 'spam', return our custom display
    if (flag.type() === 'spam') {
      const reason = flag.reason();
      const detail = flag.reasonDetail();
      return [app.translator.trans('fof-anti-spam.forum.post.flagged_as_spam_text', {
        score: reason
      }), !!detail && m("span", {
        className: "Post-flagged-detail"
      }, detail)];
    }

    // Otherwise, return the original result
    return originalReason(flag);
  });
}
flarum.reg.add('fof-anti-spam', 'forum/extenders/addSpamFlagType', addSpamFlagType);